import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';

function LinkInsertModal({
 show, onHide, onInsert, initialText = '', initialUrl = '', title = 'Insert Link',
}) {
  const [linkText, setLinkText] = useState(initialText);
  const [linkUrl, setLinkUrl] = useState(initialUrl);

  // Sync initial values when modal opens
  useEffect(() => {
    if (show) {
      setLinkText(initialText);
      setLinkUrl(initialUrl);
    }
  }, [show, initialText, initialUrl]);

  const isValid = linkUrl.trim().length > 0;

  const handleInsert = useCallback(() => {
    if (!isValid) return;
    onInsert(linkUrl.trim(), linkText.trim());
    setLinkText('');
    setLinkUrl('');
  }, [isValid, linkUrl, linkText, onInsert]);

  const handleClose = () => {
    onHide();
    setLinkText('');
    setLinkUrl('');
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Text</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter text"
              value={linkText}
              onChange={(e) => setLinkText(e.target.value)}
              autoFocus
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Link</Form.Label>
            <Form.Control
              type="url"
              placeholder="Type or paste a link"
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleInsert();
                }
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleInsert} disabled={!isValid}>
          {title === 'Edit Link' ? 'Update Link' : 'Add Link'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

LinkInsertModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onInsert: PropTypes.func.isRequired,
  initialText: PropTypes.string,
  initialUrl: PropTypes.string,
  title: PropTypes.string,
};

export default LinkInsertModal;
